<template>
  <div id="sales-invoices" class="px-4 py-4">
    <sales-invoice-list />
  </div>
</template>
<script>
import SalesInvoiceList from "@/components/finance/SalesInvoiceList.vue";
export default {
  components: {
    SalesInvoiceList
  }
};
</script>
